import React, { useContext } from 'react'
import Grid, { Row, Cell } from '../Grid'
import { appendUtmQueryParamsToALink } from '../appendUtmQueryParams'
import { UtmCampaignEnum } from '../../UtmCampaignEnum'
import { isColorDark } from 'shared/colorUtils'
import { OrgContext } from '../../EmailTemplate'

interface IProps {
  link: string
  text: JSX.Element | string
  utmCampaign?: UtmCampaignEnum
}

export default function ButtonLink({ link, text, utmCampaign }: IProps) {
  if (utmCampaign) {
    link = appendUtmQueryParamsToALink(link, utmCampaign)
  }

  const { buttonPrimary } = useContext(OrgContext)

  return (
    <Grid
      style={{
        width: '100%'
      }}
    >
      <Row>
        <Cell style={{ padding: '16px 0' }}>
          <Grid
            style={{
              width: 'auto',
              margin: 'auto',
              borderRadius: '4px',
              backgroundColor: `${buttonPrimary}`,
              backgroundImage: `linear-gradient(${buttonPrimary}, ${buttonPrimary})`
            }}
          >
            <Row>
              <Cell
                bgcolor={buttonPrimary}
                style={{
                  borderRadius: '4px',
                  overflow: 'hidden',
                  backgroundColor: `${buttonPrimary}`,
                  backgroundImage: `linear-gradient(${buttonPrimary}, ${buttonPrimary})`
                }}
                align="center"
              >
                <a
                  className="ButtonLink"
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: '16px',
                    color: isColorDark(buttonPrimary) ? '#ffffff' : '#0a141e',
                    textDecoration: 'none',
                    lineHeight: '24px',
                    display: 'inline-block',
                    textAlign: 'center',
                    border: `16px solid ${buttonPrimary}`
                  }}
                >
                  <span
                    style={{
                      fontSize: '16px',
                      color: isColorDark(buttonPrimary) ? '#ffffff' : '#0a141e',
                      textAlign: 'center',
                      textDecoration: 'none',
                      lineHeight: '24px',
                      fontFamily: 'Helvetica,Arial,sans-serif'
                    }}
                  >
                    &nbsp;
                    {text}
                    &nbsp;
                  </span>
                </a>
              </Cell>
            </Row>
          </Grid>
        </Cell>
      </Row>
    </Grid>
  )
}
